import { Component, Input } from '@angular/core';
import { IColunaTabela } from 'src/app/interfaces';

@Component({
  selector: 'app-checkbox-visualizacao-coluna-tabela',
  templateUrl: './checkbox-visualizacao-coluna-tabela.component.html',
  styleUrls: ['./checkbox-visualizacao-coluna-tabela.component.scss']
})
export class CheckboxVisualizacaoColunaTabelaComponent {
  @Input() colunasTabela: IColunaTabela[] = [];
}
